export function initGallery() {
  if (!document.querySelector('[data-component="gallery"]')) {
    return () => { };
  }

  const GLightbox = window.GLightbox ?? window.big5Vendor?.GLightbox;

  if (typeof GLightbox !== 'function') {
    return () => { };
  }

  const instance = GLightbox({
    selector: '[data-component="gallery"] .glightbox',
    loop: true,
    touchNavigation: true,
    keyboardNavigation: true,
    closeOnOutsideClick: true,
    openEffect: 'zoom',
    closeEffect: 'zoom',
    slideEffect: 'slide',
    svg: {
      close: '<svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="51.3345" height="51.3345" fill="#BF1F3E"/><path d="M36.6274 14L14 36.6274L14.7071 37.3345L37.3345 14.7071L36.6274 14Z" fill="#FFFAF5"/><path d="M37.3344 36.6274L14.707 14L13.9999 14.7071L36.6273 37.3345L37.3344 36.6274Z" fill="#FFFAF5"/></svg>',
      next: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none"><path d="M8.87871 15.763L9.35306 16.2373L17.4155 8.08265L9.33282 0L8.85846 0.474354L16.128 7.74383H0V8.42147H16.128L8.87871 15.763Z" fill="#FFFAF5"/></svg>',
      prev: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none"> <path d="M8.5373 15.763L8.06295 16.2373L0.000469208 8.08265L8.0832 0L8.55756 0.474354L1.288 7.74383H17.416V8.42147H1.288L8.5373 15.763Z" fill="#FFFAF5"/></svg>'
    }
  });

  return () => {
    instance.destroy();
  };
}
